/* zoneCreation.js - Simpler functions that create and populate a zone, without getting into geometry, inheritance,
   or higher-level operations. */
import { cloneDeep, sampleSize } from 'lodash';
import { inputStates } from 'constants/values';
import { applicationTypes } from 'constants/scripts';
import { getFeature } from 'geometry/geojson/convert';

/** Copy meta data from an existing zone to a new one, preserving the new zone's zone ID and setting a few
    members to indicate newness of the zone. */
export const copyZoneMeta = (toZone, fromZone) => {
  const fromZoneMeta = cloneDeep(fromZone.meta);
  toZone.meta = {
    ...fromZoneMeta, // Copy over all the .meta except...
    zoneId:toZone.meta && toZone.meta.zoneId,
    index: null,
    inputState: inputStates.CHANGED,
    isCheckStrip: toZone.meta?.isCheckStrip
  };
};

export const generateZoneId = (zones) => {
  const otherZoneIds = Object.keys(zones);
  for(;;) {
    const randomId = sampleSize('abcdefghijklmnopqrstuvwxyz0123456789', 6).join('');
    if (otherZoneIds.indexOf(randomId) === -1) {
      return randomId; // Only return ID if unique. (rare case that it wouldn't be)
    }
  }
};

export const getNextZoneIndex = (zones) => {
  let highestIndex = -1;
  Object.keys(zones).forEach(zoneId => {
    const zone = zones[zoneId];
    if (!isNaN(zone.meta.index) && zone.meta.index > highestIndex) { highestIndex = zone.meta.index; }
  });
  return highestIndex + 1;
};

export const createNewZone = ({ geoJson, zoneId, isCheckStrip }) => {
  const feature = getFeature(geoJson);
  return {
    geoJson: {...feature, properties: {} }, // Strip out any passed-in geoJson.properties.
    meta: {
      zoneId,
      applications: {
        [`${applicationTypes.APPLICATION}`]: [],
        [`${applicationTypes.FERTILIZER}`]: [],
        [`${applicationTypes.SEED}`]: [],
        [`${applicationTypes.STABILIZER}`]: []
      },
      isCheckStrip
    }
  };
};
